import { faqsTypes } from "./faqTypes";
import _ from "lodash";

const INITIAL_STATE = {
  panel1: true,
  errorMessage: "",
  faqsList: [],
  selectedFaqs: [],
  faqCategories: [],
};

const FaqReducer = (state, action) => {
  if (!state) state = INITIAL_STATE;
  switch (action.type) {
    case faqsTypes.FAQ_ONCHANGE:
      return {
        ...state,
        errorMessage: "",
        [action.payload.prop]: action.payload.value,
      };
    case faqsTypes.SELECTED_FAQS: {
      const newState = { ...state };
      const selectedFaq = action.payload;

      const faqExist = newState.selectedFaqs.find((faq) => {
        return faq.id === selectedFaq.id;
      });

      if (faqExist && newState.selectedFaqs.length > 0) {
        _.remove(newState.selectedFaqs, (faq) => {
          return faq.id === selectedFaq.id;
        });
      } else {
        newState.selectedFaqs.push(selectedFaq);
      }
      return newState;
    }
    case faqsTypes.ALL_SELECTED_FAQS: {
      return {
        ...state,
        selectedFaqs: action.payload,
      };
    }
    default:
      return state;
  }
};

export default FaqReducer;
